module.exports = __webpack_public_path__ + "static/media/IMG_7285_DxO.8e9d3c9c.jpg";